<template>
  <div class="body-content">
    <discuss-category @areaChange="handleAreaChange"></discuss-category>
    <div class="index-container">
      <div class="index-main">
        <div class="form-group">
          <label for="examPaper">试卷</label>
          <el-select v-model="examPaper" filterable remote reserve-keyword placeholder="请先选择省份，再输入试卷名称搜索"
            :remote-method="handlePaperSearch" :loading="loading" class="paper-select" @change="handlePaperChange">
            <el-option v-for="item in paperOptions" :key="item.paperId" :label="item.title"
              :value="item.paperId"></el-option>
          </el-select>
        </div>

        <div class="form-group">
          <label for="answerSource">答案来源</label>
          <input id="answerSource" type="text" v-model="answerSource" required placeholder="请输入答案来源机构">
        </div>

        <div class="add-rules">
          <p class="add-desc">1.补充的答案审核通过后，将会显示在页面中，你将获得{{ rewardDays }}天纯净版会员；</p>
          <p class="add-desc">2.已有的4家机构和网友上传答案，不要重复上传；</p>
          <p class="add-desc">3.不要补充自己写的答案，低质量答案会被定期删除；</p>
        </div>

        <div class="question-tabs">
          <button v-for="(question, index) in questions" :key="index" class="tab-button"
            :class="{ active: currentQuestionIndex === index + 1 }" @click="setCurrentQuestion(question)">
            第{{ index + 1 }}题
          </button>
        </div>

        <template v-if="currentQuestion?.content">
          <div class="ql-editor" style="height: auto;padding: 0;">
            <div v-html="currentQuestion?.content" class="content-area"></div>
          </div>

          <div class="answer-box">
            <quill-editor v-model="answer" :options="editorOption" @change="onEditorChange($event)" ref="quillEditor" />
            <!-- 隐藏的文件上传输入框 -->
            <input
              type="file"
              ref="ocrFileInput"
              style="display: none"
              accept="image/*"
              @change="handleOcrImageUpload"
            />
          </div>
          <div class="answer-actions">
            <button @click="confirmSubmitAnswer" class="action-button">提交答案</button>
          </div>
        </template>
        <template v-else>
          <div class="empty-question">
            <i class="el-icon-document icon"></i>
            <div class="text">请先选择试卷和题目</div>
          </div>
        </template>
      </div>
    </div>
    <div class="right-section">
      <tool-box class="tool-box"></tool-box>
    </div>
  </div>
</template>

<script>
import discussCategory from '@/components/business/discuss/discussCategory.vue';
import toolBox from '@/components/business/discuss/toolBox.vue';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { MessageBox } from 'element-ui';
import { getPaperList, getQuestionList, insertReferenceAnswer, getOcr } from '@/api';
import { uploadMinioUrl } from '@/api';

export default {
  name: "AddAnswerPage",
  components: {
    'discuss-category': discussCategory,
    'tool-box': toolBox,
    quillEditor
  },
  data() {
    return {
      examPaper: '',
      answerSource: '',
      answer: '',
      currentQuestionIndex: 1,
      loading: false,
      paperOptions: [],
      selectedArea: null,
      questions: [],
      uploadingOcr: false, // OCR上传状态
      ocrButtonAdded: false, // OCR按钮是否已添加
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        },
        placeholder: '请输入您的答案'
      }
    }
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex - 1] || {};
    },
    areaList() {
      return this.$store.getters["category/getState"].areaCategoryList;
    },
    // 根据 dataType 计算奖励天数：0=公务员1天，1=事业单位2天
    rewardDays() {
      const dataType = this.$store.state.user.dataType;
      return dataType === 1 ? 2 : 1;
    }
  },
  mounted() {
    // 不在这里添加OCR按钮，因为编辑器可能还没有渲染
  },
  created() {
    if (this.areaList.length === 0) {
      this.$store.dispatch('category/GetAreaList').then(() => {
        this.initPageData();
      });
    } else {
      this.initPageData();
    }
  },
  methods: {
    initPageData() {
      const routePaperId = this.$route.query.paperId;
      const normalizedPaperId = routePaperId == null ? '' : String(routePaperId).trim();
      if (normalizedPaperId && !['undefined', 'null'].includes(normalizedPaperId.toLowerCase())) {
        this.initFromRoute(normalizedPaperId);
        return;
      }

      if (this.areaList.length > 0) {
        this.selectedArea = this.areaList[0].areaId;
        this.handlePaperSearch('');
      }
    },
    async initFromRoute(paperId) {
      try {
        const response = await getPaperList({
          paperId,
          pageSize: 1,
          pageNum: 1
        });
        const paper = (response.rows || [])[0];

        if (paper) {
          this.selectedArea = paper.areaId || (this.areaList[0] && this.areaList[0].areaId);
          this.paperOptions = [paper];
          this.examPaper = paper.paperId;
        } else if (this.areaList.length > 0) {
          this.selectedArea = this.areaList[0].areaId;
          this.examPaper = paperId;
        }

        await this.getQuestionList(paperId, Number(this.$route.query.questionIndex) || 1);
      } catch (error) {
        this.$message.error(error);
        if (this.areaList.length > 0) {
          this.selectedArea = this.areaList[0].areaId;
          this.handlePaperSearch('');
        }
      }
    },
    // 添加OCR按钮到工具栏
    addOcrButtonToToolbar() {
      // 如果按钮已添加，直接返回
      if (this.ocrButtonAdded) {
        console.log('OCR按钮已添加过，跳过');
        return;
      }

      // 等待DOM完全加载
      setTimeout(() => {
        const toolbar = document.querySelector('.ql-toolbar.ql-snow');
        if (toolbar) {
          // 先检查是否已经有OCR按钮，避免重复添加
          const existingOcrButton = toolbar.querySelector('.ql-ocr');
          if (existingOcrButton) {
            console.log('OCR按钮已存在，跳过添加');
            this.ocrButtonAdded = true;
            return; // 已存在，不再添加
          }

          // 创建OCR按钮容器
          const ocrButtonContainer = document.createElement('div');
          ocrButtonContainer.className = 'ql-formats';

          // 创建OCR按钮
          const ocrButton = document.createElement('button');
          ocrButton.className = 'ql-ocr';
          ocrButton.type = 'button';

          // 创建图标
          const ocrIcon = document.createElement('img');
          ocrIcon.src = require('@/assets/images/ocr.png');
          ocrIcon.alt = 'OCR';
          ocrIcon.style.cssText = `
            width: 18px;
            height: 18px;
            display: block;
          `;

          // 添加点击事件
          ocrButton.addEventListener('click', () => {
            this.triggerOcrUpload();
          });

          // 组装按钮
          ocrButton.appendChild(ocrIcon);
          ocrButtonContainer.appendChild(ocrButton);

          // 添加到工具栏最后面
          toolbar.appendChild(ocrButtonContainer);

          // 添加按钮样式
          ocrButton.style.cssText = `
            background: none;
            border: none;
            cursor: pointer;
            padding: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            transition: background-color 0.2s;
          `;

          // 添加悬停效果
          ocrButton.addEventListener('mouseenter', () => {
            ocrButton.style.backgroundColor = '#f0f0f0';
          });

          ocrButton.addEventListener('mouseleave', () => {
            ocrButton.style.backgroundColor = 'transparent';
          });

          console.log('OCR按钮添加成功');
          this.ocrButtonAdded = true;
        } else {
          console.warn('未找到Quill编辑器工具栏，重试中...');
          // 如果没找到工具栏，延迟重试
          setTimeout(() => {
            this.addOcrButtonToToolbar();
          }, 500);
        }
      }, 200); // 减少延迟时间
    },

    // 触发OCR图片上传
    triggerOcrUpload() {
      console.log('OCR按钮被点击');
      if (this.$refs.ocrFileInput) {
        this.$refs.ocrFileInput.click();
      } else {
        console.error('无法找到文件输入框');
      }
    },

    // 处理OCR图片上传
    async handleOcrImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        return;
      }

      // 检查文件大小 (5MB限制)
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        return;
      }

      this.uploadingOcr = true;
      this.$message.info('正在上传图片并进行OCR识别...');

      try {
        // 1. 上传图片到MinIO
        const formData = new FormData();
        formData.append('file', file);

        const uploadResponse = await fetch(uploadMinioUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + this.$store.getters['user/getState'].token
          }
        });

        const uploadResult = await uploadResponse.json();

        if (uploadResult && uploadResult.url) {
          const imageUrl = uploadResult.url;

          // 2. 调用OCR识别
          const ocrResponse = await getOcr({
            imgUrl: imageUrl
          });

          if (ocrResponse.data && ocrResponse.data.items) {
            // 3. 处理OCR结果
            let recognizedText = '';
            for (let key in ocrResponse.data.items) {
              let item = ocrResponse.data.items[key];
              recognizedText = recognizedText.concat(item.text);
            }

            if (recognizedText.trim()) {
              // 4. 将识别结果插入到富文本编辑器
              this.insertOcrResult(recognizedText);
              this.$message.success('OCR识别完成，已插入到编辑器中');
            } else {
              this.$message.warning('未能识别到文字内容，请尝试更清晰的图片');
            }
          } else {
            this.$message.error('OCR识别失败，请重试');
          }
        } else {
          this.$message.error('图片上传失败，请重试');
        }
      } catch (error) {
        console.error('OCR处理失败:', error);
        this.$message.error('OCR处理失败，请重试');
      } finally {
        this.uploadingOcr = false;
        // 清空文件输入框
        event.target.value = '';
      }
    },

    // 插入OCR识别结果到编辑器
    insertOcrResult(text) {
      if (this.$refs.quillEditor) {
        const quill = this.$refs.quillEditor.quill;
        // 获取当前光标位置
        const range = quill.getSelection();
        if (range) {
          // 在光标位置插入文本
          quill.insertText(range.index, text);
        } else {
          // 如果没有光标，在末尾插入文本
          const length = quill.getLength();
          quill.insertText(length, text);
        }
        // 更新v-model
        this.answer = quill.root.innerHTML;
      }
    },

    handleAreaChange(areaId) {
      this.selectedArea = areaId;
      this.examPaper = ''; // 清空已选试卷
      this.paperOptions = []; // 清空试卷选项
      this.questions = []; // 清空问题列表
      this.currentQuestionIndex = 1; // 重置当前问题索引
      this.handlePaperSearch(''); // 重新获取试卷列表
    },

    handlePaperSearch(query) {
      if (!this.selectedArea) {
        this.$message.warning('请先选择地区');
        return;
      }
      
      this.loading = true;
      getPaperList({
        pageSize: 20,
        pageNum: 1,
        areaId: this.selectedArea,
        keyword: query
      }).then(response => {
        this.paperOptions = response.rows || [];
        this.loading = false;
      }).catch(error => {
        this.$message.error(error);
        this.loading = false;
        this.paperOptions = [];
      });
    },

    // 监听试卷选择变化
    handlePaperChange(value) {
      if (value) {
        this.getQuestionList(value);
      } else {
        this.questions = [];
        this.currentQuestionIndex = 1;
      }
    },

    // 获取问题列表
    getQuestionList(paperId, questionIndex) {
      const params = {
        paperId: paperId,
        pageSize: 1000,
        pageNum: 1
      };
      return getQuestionList(params).then(response => {
        this.questions = response.rows || [];
        if (questionIndex && this.questions.some(question => question.questionIndex === questionIndex)) {
          this.currentQuestionIndex = questionIndex;
        } else {
          this.currentQuestionIndex = 1;
        }
        // 等待DOM更新后添加OCR按钮
        this.$nextTick(() => {
          setTimeout(() => {
            this.addOcrButtonToToolbar();
          }, 100);
        });
      }).catch(error => {
        this.$message.error(error);
        this.questions = [];
        throw error;
      });
    },

    setCurrentQuestion(question) {
      if (question && question.questionIndex) {
        this.currentQuestionIndex = question.questionIndex;
        this.answer = ''; // 清空答案
      }
    },

    onEditorChange({ quill, html, text }) {
      this.answer = html;
    },

    confirmSubmitAnswer() {
      if (!this.examPaper) {
        this.$message.warning('请选择试卷');
        return;
      }
      
      MessageBox.confirm('确定要提交答案吗？', '提交确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitAnswer();
      }).catch(() => {
        // 用户点击取消，不做任何操作
      });
    },

    async submitAnswer() {
      try {
        if (!this.answer.trim()) {
          this.$message.warning('请输入答案内容');
          return;
        }

        if (!this.answerSource.trim()) {
          this.$message.warning('请输入答案来源');
          return;
        }

        const data = {
          content: this.answer,
          userId: this.$store.getters['user/getState'].userId,
          questionId: this.currentQuestion.questionId,
          source: this.answerSource,
          status: "0" // 0代表未审核 1代表审核通过 2代表审核拒绝
        };

        await insertReferenceAnswer(data);
        this.$message.success('答案提交成功，等待审核');
        this.resetForm();
      } catch (error) {
        console.error('提交答案错误:', error);
        this.$message.error('提交过程中发生错误，请重试');
      }
    },

    resetForm() {
      this.examPaper = '';
      this.answerSource = '';
      this.answer = '';
      this.currentQuestionIndex = 1;
      this.paperOptions = [];
      this.questions = [];
      this.ocrButtonAdded = false; // 重置OCR按钮状态
    }
  },
  watch: {
    examPaper(newVal) {
      this.handlePaperChange(newVal);
    }
  }
}
</script>

<style lang="scss" scoped>
.body-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;

  .index-container {
    display: flex;
    position: relative;
    margin-left: 168px;
    flex: 1;
    min-width: 0;

    .index-main {
      width: 100%;
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;
      margin-right: 320px;

      .empty-question {
        text-align: center;
        padding: 40px 0;
        color: #909399;
        font-size: 14px;

        .icon {
          font-size: 48px;
          margin-bottom: 16px;
          color: #DCDFE6;
        }

        .text {
          color: #909399;
        }
      }
    }
  }
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  label {
    width: 60px;
    margin-right: 5px;
    white-space: nowrap;
  }

  ::v-deep .paper-select {
    flex: 1;
    border: 1px solid #ccc;
    border-radius: 4px;

    // 添加 placeholder 样式
    .el-input__inner::placeholder {
      color: #999; // 设置占位符颜色
      font-size: 12px; // 设置占位符字体大小
    }

    .el-input__inner {
      background-color: #fff !important;

      &::placeholder {
        color: #999; // 设置占位符颜色
        font-size: 12px; // 设置占位符字体大小
      }
    }

    .el-select-dropdown__item {
      background-color: #fff;

      &:hover {
        background-color: #f5f7fa;
      }
    }
  }

  input {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 4px 14px;
    flex: 1;

    &::placeholder {
      color: #999;
      font-size: 12px;
    }
  }
}

.add-rules {
  margin: 16px 0 24px;
  padding: 12px 16px;
  background-color: #f9f9f9;
  border-radius: 8px;

  .add-desc {
    color: #666;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.right-section {
    width: 300px;
    min-height: auto;
    max-height: calc(100vh - 100px);
    position: fixed;
    top: 80px;
    right: calc((100vw - 1200px) / 2 + 20px);
    background-color: $background-color;
    border-radius: 10px;
    transition: all .2s;
    overflow-y: auto;

    /* 隐藏滚动条但保持滚动功能 */
    &::-webkit-scrollbar {
      width: 0;
      display: none;
    }

    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

.question-tabs {
  display: flex;
  margin-bottom: 10px;
}

.tab-button {
  padding: 5px 10px;
  margin-right: 10px;
  border: none;
  background: none;
  cursor: pointer;
}

.tab-button.active {
  border-bottom: 2px solid #46B4B1;
  color: #46B4B1;
}


.answer-box {
  margin-top: 20px;
  margin-bottom: 20px;
}

.answer-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-top: 20px;
}

.action-button {
  padding: 6px 10px;
  background-color: #46B4B1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 14px;

  &:hover {
    background-color: #378F8C;
  }
}

.content-area {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  .header {
    .left {
      color: #46B4B1;
    }
  }
}
</style>
